import React from "react";
import styles from "./Testimonials.module.css";

const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    country: "United Kingdom",
    rating: 5,
    quote:
      "The dune bashing was thrilling and our guide made sure we felt safe the whole time. Dinner at the camp was a highlight!",
  },
  {
    id: 2,
    name: "Ahmed K.",
    country: "Saudi Arabia",
    rating: 5,
    quote:
      "Booked the Premium package for my family. Smooth pickup, great food, and the kids loved the camel rides.",
  },
  {
    id: 3,
    name: "Elena R.",
    country: "Italy",
    rating: 4,
    quote:
      "Beautiful sunset views and a well-organized evening. Would book again on our next trip to Dubai.",
  },
];

function Testimonials() {
  return (
    <section className={styles.section}>
      <div className="container">
        <h2 className={styles.title}>What Our Guests Say</h2>

        <div className="row g-3">
          {testimonials.map((t) => (
            <div key={t.id} className="col-12 col-md-4">
              <div className={styles.card}>
                <p className={styles.stars}>
                  {"★".repeat(t.rating)}
                  {"☆".repeat(5 - t.rating)}
                </p>
                <p className={styles.quote}>&ldquo;{t.quote}&rdquo;</p>
                <p className={styles.name}>{t.name}</p>
                <p className={styles.country}>{t.country}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
